var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWatch = function SvgWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.453 11.895C13.302 12.522 12.586 12.965 11.153 13.85C9.77 14.706 9.078 15.135 8.52 14.963C8.28566 14.8879 8.07526 14.7523 7.91 14.57C7.5 14.12 7.5 13.246 7.5 11.5C7.5 9.75401 7.5 8.88001 7.91 8.43001C8.08 8.24401 8.29 8.10901 8.52 8.03801C9.078 7.86501 9.77 8.29401 11.154 9.15001C12.586 10.036 13.302 10.479 13.454 11.105C13.516 11.3647 13.516 11.6353 13.454 11.895H13.453Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19.998 10C19.9993 10.47 20 10.97 20 11.5C20 15.978 20 18.218 18.609 19.609C17.218 21 14.979 21 10.5 21C6.022 21 3.782 21 2.391 19.609C1 18.218 1 15.979 1 11.5C1 7.022 1 4.782 2.391 3.391C3.782 2 6.021 2 10.5 2C11.03 2 11.53 2.00067 12 2.002",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M17.5 1L17.758 1.697C18.096 2.611 18.265 3.068 18.598 3.401C18.932 3.735 19.389 3.904 20.303 4.242L21 4.5L20.303 4.758C19.389 5.096 18.932 5.265 18.599 5.598C18.265 5.932 18.096 6.389 17.758 7.303L17.5 8L17.242 7.303C16.904 6.389 16.735 5.932 16.402 5.599C16.068 5.265 15.611 5.096 14.697 4.758L14 4.5L14.697 4.242C15.611 3.904 16.068 3.735 16.401 3.402C16.735 3.068 16.904 2.611 17.242 1.697L17.5 1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
};
export default SvgWatch;